import UnsupportedQuestionType from './UnsupportedQuestionType';
export type { UnsupportedQuestionTypeProps } from './UnsupportedQuestionType.types';

export default UnsupportedQuestionType;
